export enum ECompanionSimultaneousType {
  Count = 0,
  Sequence = 1,
}


